import { OrderRequest } from '@shared/model/order';
import dayjs from 'dayjs';

export const sortRequestByCreateDate = (requests: OrderRequest[]) => {
    return [...requests].sort((prev, current) => {
        const prevDate = dayjs(prev.createdAt);
        const currentDate = dayjs(current.createdAt);

        return currentDate.isAfter(prevDate) ? 1 : -1;
    });
};
